import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { reduce } from '@beef/utils';
import PropTypes from 'prop-types';
import { CrudeMappingModule, selectCrudeMappingContext, selectCrudeMappingState } from "../../store";
import { enhancedConnect } from "../../../enhancedConnect";
var mapKeys = function mapKeys(object, fn) {
  return reduce(object, function (accum, value, key) {
    return _objectSpread(_objectSpread({}, accum), {}, _defineProperty({}, fn(key, value), value));
  }, {});
};
export var CrudeProvider = function CrudeProvider(_ref) {
  var children = _ref.children,
    _ref$alias = _ref.alias,
    alias = _ref$alias === void 0 ? '' : _ref$alias,
    value = _ref.value,
    _ref$extra = _ref.extra,
    extra = _ref$extra === void 0 ? {} : _ref$extra;
  var prevContext = useSelector(selectCrudeMappingContext);
  var prevState = useSelector(selectCrudeMappingState);
  var getPrevState = useMemo(function () {
    return function () {
      return prevState;
    };
  }, [prevState]);
  var nextContext = useMemo(function () {
    return function () {
      return _objectSpread(_objectSpread({}, prevContext), {}, _defineProperty({}, alias, value), mapKeys(extra, function (key) {
        return "".concat(alias, "__").concat(key);
      }));
    };
  }, [prevContext, alias, value, extra]);
  return /*#__PURE__*/React.createElement(CrudeMappingModule, {
    context: nextContext,
    state: getPrevState,
    "data-t-id": "components-CrudeContext"
  }, children);
};
export var CrudeContext = enhancedConnect({
  children: PropTypes.node,
  alias: PropTypes.string,
  value: PropTypes.any,
  extra: PropTypes.any
})(CrudeProvider);